module.exports = {"groups":{"common-questions":"Preguntas comunes"},"faqs":{"existe-algun-tipo-de-publicidad-directa-o-indirecta":"For us, security and transparency are essential elements when we talk about the field of health. For this reason:<br><br>- We do NOT offer professionals the possibility of appearing prominently in search results by contracting a premium account.<br><br>- We do NOT include any type of third-party advertising on our platform or in communications with our users.<br><br>- We do NOT transfer data to third parties for advertising purposes."}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/es/public/views/faqs.json
// module id = 329
// module chunks = 116